import React, { useState, lazy } from 'react';
import { SparklesIcon, CheckCircleIcon, TagIcon, ShoppingCartIcon, XIcon, GiftIcon } from 'lucide-react';
export function PricingSection() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const bundleIncludes = [{
    title: '📖 EBOOK Principal: 30 Recetas para Bebés',
    subtitle: 'Método paso a paso para mamás primerizas en Latinoamérica',
    isMain: true
  }, {
    title: '🎁 BONO 1: Bebé Feliz - Nutrición Segura para Bebés',
    subtitle: 'Menús saludables sin leche ni huevo para bebés',
    isMain: false
  }, {
    title: '🎁 BONO 2: Menús Completos para Bebés Sin Leche Ni Huevos',
    subtitle: 'Un método paso a paso para mamás primerizas',
    isMain: false
  }, {
    title: '🎁 BONO 3: Cocina Express para Bebés Saludables',
    subtitle: 'Método paso a paso de meal prep para mamás primerizas',
    isMain: false
  }, {
    title: '🎁 BONO 4: Método con Sabor Latino para Bebés',
    subtitle: 'Guía completa para bebés adaptada a nuestra cultura',
    isMain: false
  }, {
    title: '🎁 BONO 5: Agenda Mágica de Comidas para Bebé',
    subtitle: 'Método para mamás primerizas',
    isMain: false
  }, {
    title: '🎁 BONO 6: Manual Visual de Alimentación Infantil',
    subtitle: 'Método para el desarrollo de la alimentación infantil',
    isMain: false
  }];
  return <>
      <section className="py-8 sm:py-12 md:py-16 lg:py-20 bg-gradient-to-br from-baby-blue-light via-baby-lavender to-baby-pink-light" data-id="element-718">
        <div className="max-w-5xl mx-auto px-3 sm:px-4 md:px-6" data-id="element-719">
          {/* Header */}
          <div className="text-center mb-6 sm:mb-8 md:mb-12 animate-fade-in-up" data-id="element-720">
            <div className="inline-flex items-center gap-1.5 sm:gap-2 bg-white/90 backdrop-blur-baby text-baby-pink px-3 py-1.5 sm:px-4 sm:py-2 md:px-6 md:py-3 rounded-full mb-3 sm:mb-4 shadow-baby-soft border-2 border-baby-pink-light" data-id="element-721">
              <SparklesIcon className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-722" />
              <span className="font-bold text-xs sm:text-sm md:text-base" data-id="element-723">
                Oferta Especial de Lanzamiento
              </span>
            </div>
            <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-2 sm:mb-3 md:mb-4 px-2" data-id="element-724">
              Pack: "Bebé Bien Alimentado 7 en 1"
            </h2>
            <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl mx-auto px-3" data-id="element-725">
              Aprovecha la oferta de lanzamiento del Pack Bebé Bien Alimentado 7
              en 1. Pagas solo por el ebook principal y te llevas 6 bonos de
              regalo pensados para que nunca más tengas que improvisar qué darle
              de comer a tu bebé.
            </p>
          </div>

          {/* Pricing Card */}
          <div className="bg-white/95 backdrop-blur-baby rounded-baby-lg shadow-baby-glow border-2 border-baby-lavender overflow-hidden animate-fade-in-up" style={{
          animationDelay: '0.2s'
        }} data-id="element-726">
            {/* Discount Badge */}
            <div className="bg-baby-gradient-pink-blue text-white text-center py-2.5 sm:py-3 md:py-4 px-3" data-id="element-727">
              <p className="text-base sm:text-lg md:text-xl lg:text-2xl font-bold leading-tight" data-id="element-728">
                🎉 96% de Descuento - Solo por Tiempo Limitado
              </p>
            </div>

            <div className="p-4 sm:p-6 md:p-8 lg:p-10" data-id="element-729">
              {/* Descriptive Text Section */}
              <div className="bg-gradient-to-br from-baby-cream to-baby-pink-light/30 p-4 sm:p-6 md:p-8 rounded-baby-lg border-2 border-baby-lavender/50 mb-6 sm:mb-8 md:mb-10" data-id="element-730">
                <div className="prose prose-sm sm:prose-base max-w-none" data-id="element-731">
                  <p className="text-sm sm:text-base md:text-lg text-gray-800 leading-relaxed mb-4" data-id="element-732">
                    Con el ebook principal{' '}
                    <strong className="text-baby-pink" data-id="element-733">
                      "30 Recetas para Bebés"
                    </strong>{' '}
                    recibes un método paso a paso, claro y práctico, creado para
                    mamás primerizas en Latinoamérica. Además, desbloqueas{' '}
                    <strong data-id="element-734">6 recursos extra</strong> que completan todo el
                    sistema.
                  </p>

                  <p className="text-sm sm:text-base md:text-lg text-gray-800 leading-relaxed font-medium" data-id="element-735">
                    Es una oportunidad de lanzamiento para tener en un solo pack{' '}
                    <strong className="text-baby-pink" data-id="element-736">
                      recetas, menús, organización y guía visual
                    </strong>
                    . Todo listo para que tengas un plan claro de alimentación
                    para tu bebé desde hoy.
                  </p>
                </div>
              </div>

              {/* Price Display */}
              <div className="text-center mb-6 sm:mb-8 md:mb-10" data-id="element-737">
                {/* Original Price */}
                <div className="mb-3 sm:mb-4" data-id="element-738">
                  <p className="text-xs sm:text-sm md:text-base text-gray-600 mb-1 sm:mb-2" data-id="element-739">
                    Valor Real del Pack:
                  </p>
                  <p className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-400 line-through" data-id="element-740">
                    US$ 250
                  </p>
                </div>

                {/* Current Price */}
                <div className="relative inline-block" data-id="element-741">
                  <div className="absolute -inset-2 sm:-inset-3 bg-baby-gradient-pink-blue blur-xl opacity-30 animate-soft-pulse" data-id="element-742"></div>
                  <a href="https://mikioscodigital.com/cart/51716038885657:1" target="_blank" rel="noopener noreferrer" className="relative block bg-white p-4 sm:p-6 md:p-8 rounded-baby-lg border-4 border-baby-lavender shadow-baby-glow hover:shadow-baby-glow hover:scale-105 active:scale-100 transition-all cursor-pointer" data-id="element-743">
                    <p className="text-sm sm:text-base md:text-lg text-gray-900 mb-1 sm:mb-2 font-bold" data-id="element-744">
                      Hoy Solo:
                    </p>
                    <p className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold text-gray-900 mb-0.5 sm:mb-1" data-id="element-745">
                      US$ 9.95
                    </p>
                    <p className="text-xs sm:text-sm md:text-base text-gray-800 mt-1 sm:mt-2 font-semibold" data-id="element-746">
                      Pago único - Sin suscripciones
                    </p>
                    <div className="mt-3 sm:mt-4 flex items-center justify-center gap-2 text-baby-pink" data-id="element-747">
                      <ShoppingCartIcon className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-748" />
                      <span className="text-xs sm:text-sm font-bold" data-id="element-749">
                        Click para comprar
                      </span>
                    </div>
                  </a>
                </div>

                {/* Savings Badge */}
                <div className="mt-4 sm:mt-6 inline-flex items-center gap-1.5 sm:gap-2 bg-baby-cream px-3 py-1.5 sm:px-4 sm:py-2 md:px-6 md:py-3 rounded-full border-2 border-baby-pink-light" data-id="element-750">
                  <TagIcon className="w-4 h-4 sm:w-5 sm:h-5 text-baby-pink" data-id="element-751" />
                  <span className="font-bold text-sm sm:text-base md:text-lg text-gray-900" data-id="element-752">
                    Ahorras US$ 240.05
                  </span>
                </div>

                {/* Buy Button */}
                <div className="mt-6 sm:mt-8" data-id="element-753">
                  <a href="https://mikioscodigital.com/cart/51716038885657:1" target="_blank" rel="noopener noreferrer" className="group relative inline-block w-full sm:w-auto" style={{
                  perspective: '1000px'
                }} data-id="element-754">
                    {/* 3D Button Container */}
                    <div className="relative transition-all duration-500 ease-out group-hover:scale-105 group-hover:-translate-y-2" style={{
                    transformStyle: 'preserve-3d',
                    transform: 'rotateX(5deg)'
                  }} data-id="element-755">
                      {/* 3D Depth Layers */}
                      <div className="absolute inset-0 bg-gradient-to-br from-amber-400 via-pink-500 to-purple-600 rounded-2xl shadow-2xl" style={{
                      transform: 'translateZ(12px)'
                    }} data-id="element-756"></div>
                      <div className="absolute inset-0 bg-gradient-to-br from-amber-500 via-pink-600 to-purple-700 rounded-2xl" style={{
                      transform: 'translateZ(10px)'
                    }} data-id="element-757"></div>
                      <div className="absolute inset-0 bg-gradient-to-br from-amber-600 via-pink-700 to-purple-800 rounded-2xl" style={{
                      transform: 'translateZ(8px)'
                    }} data-id="element-758"></div>
                      <div className="absolute inset-0 bg-gradient-to-br from-amber-700 via-pink-800 to-purple-900 rounded-2xl" style={{
                      transform: 'translateZ(6px)'
                    }} data-id="element-759"></div>
                      <div className="absolute inset-0 bg-gradient-to-br from-amber-800 via-pink-900 to-purple-950 rounded-2xl" style={{
                      transform: 'translateZ(4px)'
                    }} data-id="element-760"></div>

                      {/* Main Button Surface */}
                      <div className="relative px-8 py-5 sm:px-10 sm:py-6 md:px-12 md:py-7 rounded-2xl overflow-hidden" style={{
                      transform: 'translateZ(14px)'
                    }} data-id="element-761">
                        {/* Animated gradient background */}
                        <div className="absolute inset-0 bg-gradient-to-r from-amber-400 via-pink-500 to-purple-600 animate-gradient-x" data-id="element-762"></div>

                        {/* Glossy shine overlay */}
                        <div className="absolute inset-0 bg-gradient-to-b from-white/40 via-transparent to-transparent opacity-60" data-id="element-763"></div>

                        {/* Shimmer effect */}
                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" data-id="element-764"></div>

                        {/* Button content */}
                        <div className="relative flex items-center justify-center gap-3" data-id="element-765">
                          <ShoppingCartIcon className="w-6 h-6 sm:w-7 sm:h-7 text-white drop-shadow-lg animate-bounce" data-id="element-766" />
                          <span className="font-black text-xl sm:text-2xl md:text-3xl text-white uppercase tracking-wide drop-shadow-2xl" data-id="element-767">
                            ¡Quiero Mi Pack Ahora!
                          </span>
                        </div>
                      </div>

                      {/* Outer glow effect */}
                      <div className="absolute inset-0 bg-gradient-to-r from-amber-300 via-pink-400 to-purple-500 rounded-2xl blur-2xl opacity-0 group-hover:opacity-80 transition-opacity duration-500" style={{
                      transform: 'translateZ(-10px)'
                    }} data-id="element-768"></div>

                      {/* Pulsing glow ring */}
                      <div className="absolute inset-0 bg-gradient-to-r from-amber-400 via-pink-500 to-purple-600 rounded-2xl blur-xl opacity-60 animate-pulse" style={{
                      transform: 'translateZ(-5px)'
                    }} data-id="element-769"></div>
                    </div>
                  </a>
                </div>

                {/* Promotional Image */}
                <div className="mt-4 sm:mt-6 md:mt-8 animate-fade-in-up" style={{
                animationDelay: '0.3s'
              }} data-id="element-770">
                  <div className="relative rounded-baby-lg overflow-hidden shadow-baby-glow border-2 border-baby-lavender" data-id="element-771">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eDRpvyMX6x8dF6f9zPV77T/promo1_bebe.jpg" alt="Pack Bebé Bien Alimentado 7 en 1 - 30 Recetas para Bebés + 6 ebooks de regalo" className="w-full h-auto" loading="lazy" data-id="element-772" />
                  </div>
                </div>
              </div>

              {/* What's Included */}
              <div className="bg-gradient-to-br from-baby-blue-light/50 to-baby-pink-light/50 p-4 sm:p-6 md:p-8 rounded-baby-lg border-2 border-baby-lavender/50 mb-6 sm:mb-8" data-id="element-773">
                <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900 mb-1 sm:mb-2 text-center flex items-center justify-center gap-2 flex-wrap" data-id="element-774">
                  <GiftIcon className="w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7 text-baby-pink" data-id="element-775" />
                  <span data-id="element-776">El Pack Incluye 7 Ebooks:</span>
                </h3>
                <p className="text-center text-xs sm:text-sm md:text-base text-gray-700 mb-4 sm:mb-6 font-medium" data-id="element-777">
                  1 Ebook Principal + 6 Bonos de Regalo
                </p>
                <div className="space-y-2.5 sm:space-y-3 md:space-y-4" data-id="element-778">
                  {bundleIncludes.map((item, index) => <div key={index} className={`p-3 sm:p-4 md:p-5 rounded-baby shadow-baby-soft border-2 ${item.isMain ? 'bg-baby-gradient-pink-blue text-white border-baby-pink' : 'bg-white/90 backdrop-blur-baby border-baby-lavender'}`} data-id="element-779">
                      <div className="flex items-start gap-2 sm:gap-3" data-id="element-780">
                        <CheckCircleIcon className={`w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 flex-shrink-0 mt-0.5 ${item.isMain ? 'text-white' : 'text-baby-blue'}`} data-id="element-781" />
                        <div className="flex-1 min-w-0" data-id="element-782">
                          <h4 className={`font-bold text-xs sm:text-sm md:text-base mb-0.5 sm:mb-1 leading-tight ${item.isMain ? 'text-white' : 'text-gray-900'}`} data-id="element-783">
                            {item.title}
                          </h4>
                          <p className={`text-xs sm:text-sm leading-snug ${item.isMain ? 'text-white/90' : 'text-gray-600'}`} data-id="element-784">
                            {item.subtitle}
                          </p>
                        </div>
                      </div>
                    </div>)}
                </div>
              </div>

              {/* Trust Indicators */}
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 md:gap-6 text-xs sm:text-sm md:text-base text-gray-700" data-id="element-785">
                <div className="flex items-center gap-1.5 sm:gap-2" data-id="element-786">
                  <CheckCircleIcon className="w-4 h-4 sm:w-5 sm:h-5 text-baby-blue flex-shrink-0" data-id="element-787" />
                  <span className="font-medium" data-id="element-788">Descarga Inmediata</span>
                </div>
                <div className="flex items-center gap-1.5 sm:gap-2" data-id="element-789">
                  <CheckCircleIcon className="w-4 h-4 sm:w-5 sm:h-5 text-baby-pink flex-shrink-0" data-id="element-790" />
                  <span className="font-medium" data-id="element-791">Garantía 30 Días</span>
                </div>
                <div className="flex items-center gap-1.5 sm:gap-2" data-id="element-792">
                  <CheckCircleIcon className="w-4 h-4 sm:w-5 sm:h-5 text-baby-lavender flex-shrink-0" data-id="element-793" />
                  <span className="font-medium" data-id="element-794">Pago Seguro</span>
                </div>
              </div>
            </div>
          </div>

          {/* Urgency Message */}
          <div className="mt-4 sm:mt-6 md:mt-8 text-center animate-fade-in-up" style={{
          animationDelay: '0.4s'
        }} data-id="element-795">
            <p className="text-xs sm:text-sm md:text-base text-gray-700 bg-white/80 backdrop-blur-baby px-3 py-2 sm:px-4 sm:py-3 md:px-6 md:py-4 rounded-baby inline-block border-2 border-baby-pink-light shadow-baby-soft" data-id="element-796">
              ⏰ <span className="font-bold" data-id="element-797">Oferta de lanzamiento:</span> El
              precio volverá a US$ 250 pronto
            </p>
          </div>
        </div>
      </section>
    </>;
}